/**
 * Service configuration for switching between mock and real API services
 */
export const ServiceConfig = {
  // New onboarding UX uses real APIs only; mocks remain for optional legacy local dev.
  USE_MOCK_SERVICES: false,
  
  // Authentication settings
  AUTHENTICATION: {
    // Enable or disable authentication requirement
    REQUIRE_AUTHENTICATION: false,
    // Skip authentication checks (useful for development)
    SKIP_AUTH_CHECKS: true,
  },
  
  // Mock service settings
  MOCK_SETTINGS: {
    // Simulate network delays for more realistic testing
    SIMULATE_NETWORK_DELAY: false,
    // Min and max delay in milliseconds
    MIN_DELAY: 300,
    MAX_DELAY: 1200,
  },
  
  // Real-time update settings
  REAL_TIME_SETTINGS: {
    // Default refresh interval in milliseconds (30 seconds)
    DEFAULT_REFRESH_INTERVAL: 30000,
  }
} as const;
